module.exports = __webpack_public_path__ + "assets/icons/lock-10a4.svg";